import { Observable } from "@babylonjs/core/Misc/observable.js";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { ButtonUtils, Rectangle3D, Slider3D } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { ObservableProperty } from "../utils/PropertyUtils";
export class DropdownSlider {
    get isVisible() {
        return this._mesh.isVisible;
    }
    get onPointerEnter() {
        return this._onPointerEnter;
    }
    get onPointerLeave() {
        return this._onPointerLeave;
    }
    get height() {
        return this._mesh.height;
    }
    constructor(mesh) {
        this._callback = null;
        this._minValue = new ObservableProperty(0);
        this._maxValue = new ObservableProperty(0);
        this._currentValue = new ObservableProperty(0);
        this._onPointerEnter = new Observable();
        this._onPointerLeave = new Observable();
        this.onValueChanged = (v) => {
            this._slider.value = this._currentValue.Value = v;
            if (this._callback !== null)
                this._callback(v);
        };
        this._mesh = mesh;
        const s = Env.broadcast.menu.tipMenu.toysMenuItem.dropdown.slider;
        const rootPanel = new Rectangle3D("sliderRoot");
        rootPanel.cornerRadius = this._mesh.m2px(s.layout.cornerRadiusPx);
        rootPanel.useArc = true;
        rootPanel.background = s.layout.backgroundColor;
        rootPanel.thickness = this._mesh.m2px(s.layout.borderThickness);
        rootPanel.color = s.layout.borderColor;
        rootPanel.onPointerEnterObservable.add(() => this._onPointerEnter.notifyObservers());
        rootPanel.onPointerOutObservable.add(() => this._onPointerLeave.notifyObservers());
        this._mesh.texture.addControl(rootPanel);
        this._mesh.isVisible = false;
        const stackPanel = new StackPanel("sliderStackPanel");
        stackPanel.isVertical = false;
        stackPanel.spacing = this._mesh.m2px(s.spacing);
        rootPanel.addControl(stackPanel);
        const minusButton = ButtonUtils.CreateImgButton("sliderMinusButton", s.minusButton, this._mesh);
        minusButton.onClickObserver.add(() => {
            this._currentValue.Value = Math.max(this._minValue.Value, this._currentValue.Value - 1);
        });
        stackPanel.addControl(minusButton);
        this._slider = new Slider3D("slider");
        this._slider.widthInPixels = this._mesh.m2px(s.slider.width);
        this._slider.heightInPixels = this._mesh.m2px(s.slider.height);
        this._slider.color = s.slider.color;
        this._slider.minimum = this._minValue.Value;
        this._slider.maximum = this._maxValue.Value;
        this._slider.isThumbCircle = true;
        this._slider.thumbColor = s.slider.thumbColor;
        this._slider.background = s.slider.background;
        this._slider.barOffset = this._mesh.m2px(s.slider.barOffset);
        this._slider.step = 1;
        this._slider.cornerRadius = this._mesh.m2px(s.slider.cornerRadius);
        this._slider.onValueChangedObservable.add((v) => {
            this._currentValue.Value = v;
            if (this._callback !== null)
                this._callback(v);
        });
        stackPanel.addControl(this._slider);
        const plusButton = ButtonUtils.CreateImgButton("sliderPlusButton", s.plusButton, this._mesh);
        plusButton.onClickObserver.add(() => {
            this._currentValue.Value = Math.min(this._maxValue.Value, this._currentValue.Value + 1);
        });
        stackPanel.addControl(plusButton);
        this._minValue.Subscribe((v) => {
            this._slider.minimum = v;
        });
        this._maxValue.Subscribe((v) => {
            this._slider.maximum = v;
        });
        // this._currentValue.Subscribe((v) => {
        //     if(slider.value !== v)
        //         slider.value = v;
        // });
    }
    show(position, values, callback) {
        this._callback = null;
        this._currentValue.Unsubscribe(this.onValueChanged);
        this._mesh.isVisible = true;
        this._mesh.mesh.position = position;
        this._minValue.Value = values.min;
        this._maxValue.Value = values.max;
        this._slider.value = this._currentValue.Value = values.current;
        this._callback = callback;
        this._currentValue.Subscribe(this.onValueChanged);
    }
    hide() {
        this._mesh.isVisible = false;
        this._callback = null;
        this._currentValue.Unsubscribe(this.onValueChanged);
    }
}
